import { render, staticRenderFns } from "./VisitHistorySelector.vue?vue&type=template&id=7c45effc&scoped=true&"
import script from "./VisitHistorySelector.vue?vue&type=script&lang=ts&"
export * from "./VisitHistorySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c45effc",
  null
  
)

export default component.exports